import * as React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Product, { ProductItemProps } from "../components/product-item"

const ProductsPage = ({ data }: ProductsPageProps) => (
  <Layout>
    <SEO title="Products by Gabrielle" />
    <div className="w-100 w-80-ns center">
      <h1 className="tc">Products by Gabrielle</h1>
      {data.allMarkdownRemark.edges.map(({ node }) => (
        <Product key={node.id} product={node} />
      ))}
    </div>
  </Layout>
)

export default ProductsPage

interface ProductsPageProps {
  data: {
    allMarkdownRemark: {
      edges: readonly { node: ProductItemProps & { id: number } }[]
    }
  }
}

export const fixedThumb = graphql`
  fragment fixedThumb on File {
    childImageSharp {
      fixed(height: 250) {
        ...GatsbyImageSharpFixed
      }
    }
  }
`

export const query = graphql`
  query {
    allMarkdownRemark(sort: { fields: [frontmatter___title], order: ASC }) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            cover {
              ...fixedThumb
            }
            price
            isbn
          }
          excerpt
        }
      }
    }
  }
`
